import { songsMovies } from "../video/videoUrl";
import { IChannel } from "./IChannel";
export class MusicChannel implements IChannel {
    channelMovies: any[];
    moviesNum: number;

    constructor(public setVideoSrc: (value: string) => void) {
        this.channelMovies = songsMovies;
        this.moviesNum = this.channelMovies.length;
    }

    setMovieByIndex(index: number) {
        this.setVideoSrc(this.channelMovies[index]);
    }

    getMoviesNum() {
        return this.moviesNum;
    }

    getIconLabelByIndex(index: number) {
        let label: string;
        if (index > this.moviesNum) {
            label = "none";
        } else {
            label = `song_${index}`;
        }
        return label;
    }
}
